import $ from 'jquery';

$('.teaser__more').on('click', function (e) {
    e.preventDefault();
    let $itemWrap = $(this).closest('.frame').find('.teaser__items');
    $itemWrap.find('.teaser__item-wrap--hidden').slice(0,9).removeClass('teaser__item-wrap--hidden')

    if($itemWrap.find('.teaser__item-wrap--hidden').length < 1) {
        $(this).remove();
    }
})

$(window).on('resize', function () {
    $('.teaser__items').each(function () {
        var teaserMaxHeight = 0;
        if ($(window).width() > 767) {
            var item = $(this);
            var disableHeight = false;
            setTimeout(function () {
                item.find('.teaser__item').each(function () {
                    var currHeight = $(this).find('.teaser__top-inner-content').outerHeight()
                    if (currHeight > teaserMaxHeight) {
                        teaserMaxHeight = currHeight;
                    }

                    if($(this).find('.teaser__image').length < 1) {
                        disableHeight = true;
                    }
                })
                if(!disableHeight) {
                    item.find('.teaser__top-content').height(teaserMaxHeight);
                }
            }, 300)
        }
    })
})
